import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'parseTime' })
export class ParseTimePipe implements PipeTransform {
  transform(time: string) {
    const splitTime = time.split(":");
    return `${splitTime[0]}:${splitTime[1]}`;
  }
}